<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>{{ $t("notificationsPage.title") }}</h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>
    <v-layout row wrap block>
      <v-flex xs12>
        <loading v-if="!isLoaded && !notifications" />
        <div
          class="notifications-list"
          v-if="notifications && notifications.length"
        >
          <div class="notifications-wrapper">
            <div
              :class="{
                notification: true,
                'notification-unread': !notification.read,
              }"
              v-for="(notification, idx) in notifications"
              :key="idx"
            >
              <a
                :href="getNotificationUrl(notification)"
                class="notification-link"
                v-if="
                  notification &&
                    notification.notification &&
                    notification.notification.params
                "
              >
                <div class="notification-title">
                  {{ notification.notification.data.title }}
                </div>
                <div class="notification-text">
                  {{ notification.notification.data.text }}
                </div>
                <div class="notification-time">
                  {{ dateAgo(notification.date_notification) }}
                </div>
              </a>
              <div v-else>
                <div class="notification-title">{{ notification.data }}</div>
              </div>

              <div
                class="notification-delete"
                @click="deleteNotification(notification)"
              ></div>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";

import moment from "moment";
import Noty from "noty";

export default {
  name: "Notifications",
  data: () => ({
    notifications: null,
    isLoaded: false,
    isConnected: true,
    isClosed: false,
    visible: true,
    socket: null,
  }),
  methods: {
    async getNotifications() {
      await apiCallTrue({ url: "v1/notifications" })
        .then((response) => {
          this.notifications = response.data.data ? response.data.data : [];

          this.isLoaded = true;
        })
        .catch((error) => console.log("ERROR", error));
    },
    dateAgo(date) {
      if (!date) return "";
      return moment(date)
        .locale("ru")
        .fromNow();
    },
    deleteNotification(notification) {
      apiCallTrue({ url: `v1/notifications/${notification.id}/archive` })
        .then(() => {
          const index = this.notifications.indexOf(notification);
          this.notifications.splice(index, 1);
        })
        .catch((error) => console.log("ERROR", error));
    },
    getUnreadNotificationsCount() {
      if (this.notifications && !this.notifications.length) return 0;
      const unreadNotifications = this.notifications.filter(
        (notification) => !notification.read
      );
      return unreadNotifications.length;
    },
    setNotificationsAsRead() {
      setTimeout(() => {
        // this.notifications.map(
        //     notification => (notification.status = 1)
        // );
        const method = "POST";
        const data = [];
        this.notifications.map((notification) => {
          if (!notification.read) {
            data.push(notification.id);
          }
        });

        apiCallTrue({ url: "v1/notifications/read", method, data })
          .then((response) => {
            this.notifications = response.data.data;
          })
          .catch((error) => console.log("ERROR", error));
      }, 3000);
    },
    closed() {
      this.isConnected = true;
      this.isClosed = false;
      this.socket.onclose();
      this.socket.close();
    },
    connected() {
      this.isConnected = false;
      this.isClosed = true;
      this.socket.onopen();
    },
    newWebSocket(url) {
      this.socket = new WebSocket(url);
      this.socket.onopen = (e) => {
        if (e) {
          this.isConnected = true;
          this.isClosed = false;
        }
      };
      this.socket.onmessage = (e) => {
        if (e && e.data) {
          const newMessage = JSON.parse(e.data);
          // const text = `<a href="http://ya.ru" target="_blank">${newMessage.data}</a>`;
          const text = newMessage.data ? newMessage.data : "";
          let theme = "relax";
          let layout = "topRight";
          let type = "success";
          let timeout = 0;
          // const text = ``;

          switch (newMessage.type) {
            case 1:
              if (newMessage && newMessage.action) {
                const action = JSON.parse(newMessage.action);
                layout = action.layout;
                timeout = action.timeout;
                type = action.type;
              }
              new Noty({
                theme,
                timeout,
                layout,
                type,
                text,
              }).show();
              break;
            case 2:
              // new Noty({
              //     theme: "relax",
              //     // timeout: 2000,
              //     layout: "topRight",
              //     type: "error",
              //     text
              // }).show();
              if (
                newMessage &&
                newMessage.action === "updateTopNotifications"
              ) {
                this.getNotifications();
              }
              break;
            default:
              new Noty({
                theme: "relax",
                timeout: 2000,
                layout: "topRight",
                type: "success",
                text,
              }).show();
          }
        }
      };
      this.socket.onerror = (error) => {
        console.log("WebSocket Error: " + error);
      };
      this.socket.onclose = (e) => {
        this.isConnected = true;
        this.isClosed = false;

        if (e.wasClean) {
          console.log("Соединение закрыто");
        } else {
          setTimeout(() => this.newWebSocket(this.wss), 5000);
        }
      };

      this.connected();
    },
    getNotificationUrl(notification) {
      if (
        !notification ||
        !notification.notification ||
        !notification.notification.type
      )
        return "";

      let url = "";
      switch (notification.notification.type) {
        case 1:
          url = `/tenders/${notification.notification.params}`;
          break;
        case 2:
          url = `/tenders/${notification.notification.params}`;
          break;
        case 3:
          url = `/bids/${notification.notification.params}`;
          break;
        // case 4:
        //     url = `/bids/${notification.notification.params}`;
        //     break;
        case 5:
          url = `/tasks/${notification.notification.params}`;
          break;
      }

      return url;
    },
  },
  computed: {
    ...mapGetters(["getProfile", "isAuthenticated", "isProfileLoaded"]),
    ...mapState({
      name: (state) => state.user.profile.full_name,
      role: (state) => state.user.profile.role,
      wss: (state) => state.user.profile.ws_connection_string,
    }),
    isUnreadNotifications() {
      if (!this.notifications) return 0;
      const total = this.notifications.map((item) => item.read);
      return total.indexOf(0) + 1;
    },
  },
  mounted() {
    this.getNotifications();
    if (this.wss) {
      this.newWebSocket(this.wss);
    }
  },
  watch: {
    isOpenNotifications(val) {
      if (this.notifications && !this.notifications.length) return val;
      val && this.setNotificationsAsRead();
    },
    wss(val) {
      if (val) {
        this.newWebSocket(val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app .v-menu__content {
  box-shadow: 0 0 0;
}

.notifications {
  margin: -3px 0 0;
  padding-right: 30px;
  position: relative;

  strong {
    display: inline-block;
    vertical-align: top;
    margin: 5px 0 0;
  }

  .v-icon {
    font-size: 22px !important;
  }

  &--unread {
    color: #404ce6;
  }
}

.notification {
  display: block;
  position: relative;
  padding: 12px 30px 0 0;
  margin-top: -8px;

  &-unread {
    font-weight: 600;
  }

  &-link {
    display: block;
    text-decoration: none;
    color: #222;
  }

  &-text {
    font-size: 13px;
    text-align: left;
    color: #666;
    word-break: break-all;
  }

  &-title {
    font-size: 15px;
    text-align: left;
  }
  &-time {
    font-style: italic;
    font-size: 11px;
    color: #ccc;
    text-align: left;
  }
  &-delete {
    width: 16px;
    height: 16px;
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 0px;

    &::after,
    &::before {
      content: "";
      position: absolute;
      height: 2px;
      width: 16px;
      background: #ccc;
      top: 7px;
      right: 0;
      transform: rotate(45deg);
    }
    &::before {
      transform: rotate(-45deg);
    }

    &:hover {
      &::after,
      &::before {
        background: #666;
      }
    }
  }

  & + .notification {
    margin-top: 8px;
    border-top: 1px solid #eee;
  }
}
</style>
